<ng-scrollbar orientation="vertical" (reachedBottom)="onReachedBottom()">
  <ng-content></ng-content>
</ng-scrollbar>
